package com.exura.ui

import org.jetbrains.compose.web.css.StyleScope
import org.jetbrains.compose.web.css.fontFamily

object Fonts {

    fun StyleScope.inter() {
        fontFamily(FontFamily.INTER)
    }
}

object FontFamily {
    const val INTER = "Inter"
    const val POPPINS = "Poppins"
    const val UNTILED_UI = "untiled-ui"
}

object IconFamily {
    const val UNTILED_UI = FontFamily.UNTILED_UI
}
